import { Download } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export default function Attachments({ files, label }) {
  if (!files || files.length === 0) return null;
  return (
    <div className="mt-8" data-testid="attachments">
      {label && <div className="eyebrow mb-3">{label}</div>}
      <div className="flex flex-wrap gap-3">
        {files.map((f, i) => (
          <a key={i} href={mediaUrl(f)} target="_blank" rel="noreferrer" data-testid={`attachment-${i}`}
            className="inline-flex items-center gap-2 text-sm text-[#C6899E] border border-[rgba(198,137,158,0.4)] rounded-full px-4 py-2 hover:bg-[rgba(198,137,158,0.12)] transition-colors">
            <Download className="w-4 h-4" /> {decodeURIComponent(f.split("/").pop())}
          </a>
        ))}
      </div>
    </div>
  );
}
